import { render, staticRenderFns } from "./SimpleFooter.vue?vue&type=template&id=4b686c5f&scoped=true&"
import script from "./SimpleFooter.vue?vue&type=script&lang=ts&"
export * from "./SimpleFooter.vue?vue&type=script&lang=ts&"
import style0 from "./SimpleFooter.vue?vue&type=style&index=0&id=4b686c5f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b686c5f",
  null
  
)

export default component.exports